import { useRef, useCallback } from "react";

export const sortByOrder = (items = []) =>
  [...items].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

export const reorderByIndex = (items, dragIndex, dropIndex, idKey = "id") => {
  const sorted = sortByOrder(items);
  if (dragIndex === null || dragIndex === dropIndex || dragIndex < 0 || dropIndex < 0) {
    return sorted;
  }
  const updated = [...sorted];
  const [moved] = updated.splice(dragIndex, 1);
  updated.splice(dropIndex, 0, moved);
  return updated.map((item, index) => ({ ...item, order: index + 1 }));
};

export const moveItem = (items, id, direction, idKey = "id") => {
  const sorted = sortByOrder(items);
  const index = sorted.findIndex((item) => item[idKey] === id);
  const swapWith = direction === "up" ? index - 1 : index + 1;
  if (index === -1 || swapWith < 0 || swapWith >= sorted.length) return sorted;
  return reorderByIndex(sorted, index, swapWith, idKey);
};

/** Native HTML5 drag-and-drop (same pattern as DoctorList.js prescription order). */
export const useDragReorder = (onReorder) => {
  const draggedIndexRef = useRef(null);

  const handleDragStart = useCallback((index) => {
    draggedIndexRef.current = index;
  }, []);

  const handleDragOver = useCallback((event) => {
    event.preventDefault();
  }, []);

  const handleDrop = useCallback(
    (dropIndex) => {
      const dragIndex = draggedIndexRef.current;
      draggedIndexRef.current = null;
      if (dragIndex === null || dragIndex === dropIndex) return;
      onReorder(dragIndex, dropIndex);
    },
    [onReorder],
  );

  return { handleDragStart, handleDragOver, handleDrop };
};

export { dragRowSx, dragListContainerSx } from "./managerTheme";
